import React from "react";

export const HANDOFF_WIDTH = 4;
export const HANDOFF_HEIGHT = 3;
export const HANDOFF_WIDTH_HALF = HANDOFF_WIDTH / 2;
export const HANDOFF_HEIGHT_HALF = HANDOFF_HEIGHT / 2;
export const HANDOFF_HEIGHT_OFFSET = HANDOFF_WIDTH / 5;

export interface HandoffProps {
  color?: string;
  strokeWidth?: number;
}

export const Handoff = ({ color = "#000", strokeWidth = 0.3 }: HandoffProps) => {
  return (
    <>
      <line
        x1={-HANDOFF_WIDTH_HALF}
        y1={0}
        x2={HANDOFF_WIDTH_HALF}
        y2={0}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <line
        x1={-HANDOFF_HEIGHT_OFFSET}
        y1={-HANDOFF_HEIGHT_HALF}
        x2={-HANDOFF_HEIGHT_OFFSET}
        y2={HANDOFF_HEIGHT_HALF}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <line
        x1={HANDOFF_HEIGHT_OFFSET}
        y1={-HANDOFF_HEIGHT_HALF}
        x2={HANDOFF_HEIGHT_OFFSET}
        y2={HANDOFF_HEIGHT_HALF}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </>
  );
};
